export default __webpack_public_path__ + "static/media/Mark-4-HUD-3D (Environmental Scan).dcba1bf9.jpg";